import { useMutation } from 'react-query';

import { updateUser as mutationFn } from 'api/endPoints/updateUser';

export const useMutationUpdateUser = () => {
    return useMutation<unknown, QueryError, unknown>('updateUser', (params) => mutationFn(params));
};
